import React, { FunctionComponent, useState } from 'react'
import { MenuProps } from 'antd'
import { Menu } from 'antd'
import {
  AppstoreOutlined,
  HomeOutlined,
  LoadingOutlined,
  LockOutlined,
  LogoutOutlined, MergeOutlined,
  TeamOutlined,
  UnorderedListOutlined
} from '@ant-design/icons'
import { useNavigate } from '@tanstack/react-router'
import { orange } from '@ant-design/colors'
import { backgroundColor } from '../../../../theme'
import ChangeLog from '../../ChangeLog/ChangeLog'
import { useFeathersClient } from '@strac/react-client-feathers'

type MenuItem = Required<MenuProps>['items'][number]

interface IProps {
  collapsed: boolean
  setCollapsed: (value: boolean) => void
}

const AdminMenu: FunctionComponent<any> = (props: IProps) => {
  const { collapsed } = props

  const client = useFeathersClient()

  const navigate = useNavigate()

  const [changeLog, setChangeLog] = useState<boolean>(false)
  const [selectedKey, setSelectedKey] = useState<string>('/admin')
  const [loading, setLoading] = useState<boolean>(false)

  const items: MenuItem[] = [
    {
      key: '/admin',
      icon: loading && selectedKey === '/admin' ? <LoadingOutlined /> : <AppstoreOutlined />,
      label: 'Admin',
      style: {
        backgroundColor: backgroundColor,
        color: selectedKey === '/admin' ? orange[5] : ''
      }
    },
    {
      key: '/admin/devices',
      icon: loading && selectedKey === '/admin/devices' ? <LoadingOutlined /> : <UnorderedListOutlined />,
      label: 'Devices',
      style: {
        backgroundColor: backgroundColor,
        color: selectedKey === '/admin/devices' ? orange[5] : ''
      }
    },
    {
      key: '/admin/access',
      icon: loading && selectedKey === '/admin/access' ? <LoadingOutlined /> : <LockOutlined />,
      label: 'Access',
      style: {
        backgroundColor: backgroundColor,
        color: selectedKey === '/admin/access' ? orange[5] : ''
      }
    },
    {
      key: '/admin/agencies',
      icon: loading && selectedKey === '/admin/agencies' ? <LoadingOutlined /> : <TeamOutlined />,
      label: 'Agencies',
      style: {
        backgroundColor: backgroundColor,
        color: selectedKey === '/admin/agencies' ? orange[5] : ''
      }
    },
    {
      key: '/',
      icon: loading && selectedKey === '/' ? <LoadingOutlined /> : <HomeOutlined />,
      label: 'Home',
      style: {
        border: `1px solid ${orange[5]}`,
        backgroundColor: backgroundColor,
        color: orange[5],
        position: 'absolute',
        bottom: '90px'
      }
    },
    {
      key: 'changelog',
      icon: <MergeOutlined />,
      label: 'Change Log',
      style: {
        border: '1px solid #1890ff',
        backgroundColor: backgroundColor,
        color: '#1890ff',
        position: 'absolute',
        bottom: '45px'
      },
      onClick: () => setChangeLog(true)
    },
    {
      key: '/logout',
      icon: loading && selectedKey === '/logout' ? <LoadingOutlined /> : <LogoutOutlined />,
      label: 'Logout',
      danger: true,
      style: {
        border: '1px solid red',
        position: 'absolute',
        bottom: 0
      },
      onClick: () => {
        setLoading(true)
        client.logout().then(() => {
          localStorage.removeItem('auth')
          setSelectedKey('/logout')
          navigate({ to: '/login' }).then(() => setLoading(false))
        })
      }
    }
  ]

  const onClick = (e: any) => {
    const { key } = e
    setSelectedKey(key)
    setLoading(true)
    if (key !== 'changelog') {
      navigate({ to: key }).then(() => setLoading(false))
    }
  }

  return (
    <>
      <Menu
        onClick={onClick}
        style={{ backgroundColor: backgroundColor }}
        defaultSelectedKeys={['1']}
        defaultOpenKeys={['sub1']}
        mode="inline"
        theme="dark"
        inlineCollapsed={collapsed}
        items={items}
      />
      <ChangeLog open={changeLog} setOpen={setChangeLog} />
    </>
  )
}

export default AdminMenu
